import PropTypes from "prop-types";
import React from "react";

require('./Tags.scss');

const Tags = ({values, label, deleted = false, className = ""}) => {
    return (
        <div className={`tags-container ${className}`}>
            <label className='tags-label'>{label}</label>
            <div className='tags-wrapper'>
                {
                    values.length ?
                        values.map((value, index) => <div key={index} className={`tag${deleted ? " deleted" : ""}`}>{value}</div>)
                        : '-'
                }
            </div>
        </div>
    )
};

Tags.propTypes = {
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.string,
    deleted: PropTypes.bool,
    className: PropTypes.string,
};

export default Tags;